import { Location, NavigateFunction } from 'react-router';

// индекс ключа в паре
const KEY = 0;
// индекс значения в паре
const VALUE = 1;

/**
 * функция добавляет параметры фильтров в строку `url`, передача существующего параметра
 * с новым значением произведет замену ранее выставленного значения у параметра.
 * Передача в функции существующего параметра с нулевым значением будет производить удаление параметра из `url`
 * @params `parameter: [string, unknown][]`: параметры фильтров, массив пар `['ключ', 'значение']` для фильтров
 * @params `location: Location`: локация из хука useLocation (react-router)
 * @params `navigate: NavigateFunction`: метод navigate из хука useNavigate (react-router)
 * @return {void} Происходит подмена `url` строки БЕЗ прямого редиректа
 * @example 1. Добавление нескольких параметров:
 * parameter: [['priceFrom', 3000], ['priceTo', 5000]]
 * // url: someUrl?priceFrom=3000&priceTo=5000
 * @example 2. Добавление одного параметра
 * parameter: [['workMethod', 'art-therapy']]
 * // url: someUrl?workMethod=art-therapy
 * @example 3. Удаление параметра из строки
 * // url: someUrl?workMethod=art-therapy
 * parameter: [['workMethod', '']]
 * // url: someUrl
 */
const changeParameterInRoute = (
  parameter: [string, unknown][],
  location: Location,
  navigate: NavigateFunction,
): void => {
  const newLocation = new URLSearchParams(location.search);

  parameter.forEach(pair => {
    if (
      pair[VALUE] !== undefined &&
      pair[VALUE] !== null &&
      pair[VALUE] !== ''
    ) {
      newLocation.set(pair[KEY], String(pair[VALUE]));
    } else {
      newLocation.delete(pair[KEY]);
    }
  });

  const newUrl = `${newLocation.toString()}`;
  return navigate(
    {
      pathname: location.pathname,
      search: newUrl,
    },
    { replace: true },
  );
};

export default changeParameterInRoute;
